import {
  CreditSummaryStyles,
  WelcomeStyles
} from '@com-delta-idp/mnx-fast-action-banner-ui';
import { CSSProperties } from '@com-delta-idp/mnx-ui-kit';

export interface AEMBannerConfig {
  congratulation?: string;
  showAction?: string;
  showBenefit?: string;
  showCreditSummary?: string;
  showDetails?: string;
  showHeadline?: string;
  showLinks?: string;
  showOffer?: string;
}

export interface AEMBannerStyles {
  annualFee?: CSSProperties;
  benefit?: CSSProperties;
  bullets?: CSSProperties;
  buttonLabel?: CSSProperties;
  checkLabel?: CSSProperties;
  checkSectionBackgroundColor?: string;
  containerStyles?: CSSProperties;
  details?: CSSProperties;
  heading1?: CSSProperties;
  heading2?: CSSProperties;
  image?: CSSProperties;
  linksStyles?: CSSProperties;
  welcome: WelcomeStyles;
  creditSummary: CreditSummaryStyles;
}

export interface AEMFastActionBanner {
  offerConfigs: AEMBannerConfig;
  offerStyles: AEMBannerStyles;
}
